module.exports = __webpack_public_path__ + "img/apple-app-store_ja_equalised.7b4c13c3.svg";